import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const SubCategory1 = ({ data }) => {
  const navigate = useNavigate();

  const baseImageUrl =
    "https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/";

  const categories = data.get_home_component_details.content.map((item) => ({
    id: item.subcategory_auto_id,
    name: item.sub_category_name,
    url: `/categorypage/${item.subcategory_auto_id}`,
    image: item.subcategory_image_app
      ? `${baseImageUrl}${item.subcategory_image_app}`
      : "https://via.placeholder.com/400",
  }));

  const truncateNameMobile = (name) =>
    name.length > 15 ? name.substring(0, 15) + "..." : name;

  // 👇 State for selected image (mobile main image)
  const [selectedIndex, setSelectedIndex] = useState(0);

  // ✅ Auto change image every 1 second
  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedIndex((prevIndex) =>
        prevIndex === categories.length - 1 ? 0 : prevIndex + 1
      );
    }, 1000); // 1 second

    return () => clearInterval(interval);
  }, [categories.length]);

  // ✅ Navigate directly on small image click
  const handleBoxClick = (category) => {
    navigate("/productlist", {
      state: {
        subcategoryName: category.name,
        sub_cat_id: category.id,
      },
    });
  };

  return (
    <div
      className="p-3"
      style={{
        backgroundColor: data.web_background_color,
      }}
    >
      <h3
        className={`text-${data.title_alignment} p-3 ${data.web_title_font}`}
        style={{
          color: data.web_title_color,
        }}
      >
        {data.title}
      </h3>

      {/* =================== DESKTOP VIEW =================== */}
      <div className="hidden lg:grid grid-cols-2 gap-1 justify-center overflow-hidden w-full">
        {categories.slice(0, 2).map((category) => (
          <div key={category.id} className="flex justify-center w-full">
            <div className="text-center p-2 flex items-center relative w-full">
              <Link
                to={"/productlist"}
                state={{
                  subcategoryName: category.name,
                  sub_cat_id: category.id,
                }}
                className="text-decoration-none flex flex-col items-center w-full"
              >
                <img
                  src={category.image}
                  alt={category.name}
                  className="object-cover w-full"
                  style={{ height: "600px" }}
                />
                <div
                  className={`text-black text-2xl font-bold uppercase text-center p-2 drop-shadow-lg ${data.web_title_font}`}
                >
                  {category.name}
                </div>
              </Link>
            </div>
          </div>
        ))}
      </div>

      <div className="hidden lg:grid grid-cols-3 gap-1 justify-center overflow-hidden w-full">
        {categories.slice(2, 5).map((category) => (
          <div key={category.id} className="flex justify-center w-full">
            <div className="text-center p-2 flex items-center relative w-full">
              <Link
                to={"/productlist"}
                state={{
                  subcategoryName: category.name,
                  sub_cat_id: category.id,
                }}
                className="text-decoration-none flex flex-col items-center w-full"
              >
                <img
                  src={category.image}
                  alt={category.name}
                  className="object-cover w-full"
                  style={{ height: "350px" }}
                />
                <div
                  className={`text-black text-2xl font-bold uppercase text-center p-2 drop-shadow-lg ${data.web_title_font}`}
                >
                  {category.name}
                </div>
              </Link>
            </div>
          </div>
        ))}
      </div>

      {/* =================== MOBILE VIEW =================== */}
      <div className="lg:hidden flex flex-col items-center gap-3">
        {/* 🔹 Main Auto-Sliding Image */}
        {categories[selectedIndex] && (
          <div className="relative text-center w-full transition-all duration-700 ease-in-out">
            <Link
              to="/productlist"
              state={{
                subcategoryName: categories[selectedIndex].name,
                sub_cat_id: categories[selectedIndex].id,
              }}
              className="flex flex-col items-center no-underline"
            >
              <img
                src={categories[selectedIndex].image}
                alt={categories[selectedIndex].name}
                className="object-cover w-full rounded-xl"
                style={{ height: "350px" }}
              />
              <div
                className={`text-black text-xl font-bold uppercase text-center p-2 drop-shadow-lg ${data.web_title_font}`}
              >
                {truncateNameMobile(categories[selectedIndex].name)}
              </div>
            </Link>
          </div>
        )}

        {/* 🔹 Small Scrollable Boxes */}
        <div className="flex overflow-x-auto gap-3 w-full px-2 pb-2 snap-x snap-mandatory">
          {categories.map((category, index) => (
            <div
              key={category.id}
              onClick={() => handleBoxClick(category)} // ✅ navigate directly
              className={`flex-shrink-0 snap-start text-center cursor-pointer transition-transform duration-200 ${
                selectedIndex === index ? "scale-105" : "opacity-80"
              }`}
              style={{ width: "120px" }}
            >
              <img
                src={category.image}
                alt={category.name}
                className={`object-cover w-full rounded-lg border-2 ${
                  selectedIndex === index
                    ? "border-blue-500"
                    : "border-transparent"
                }`}
                style={{ height: "120px" }}
              />
              <div
                className={`text-black text-xs font-semibold uppercase text-center mt-1 ${data.web_title_font}`}
              >
                {truncateNameMobile(category.name)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SubCategory1;
